"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));
var _History = _interopRequireDefault(require("@material-ui/icons/History"));
var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Item = _interopRequireDefault(require("../components/Item"));
var _Header = _interopRequireDefault(require("../components/Header"));
var _ModalLayout = _interopRequireDefault(require("../components/ModalLayout"));
var View = function View(_ref) {
  var title = _ref.title,
    date = _ref.date,
    price = _ref.price,
    items = _ref.items,
    onClick = _ref.onClick,
    aside = _ref.aside;
  var _items = items.filter(function (item) {
    return item.price && item.date;
  });
  return /*#__PURE__*/_react["default"].createElement(_ModalLayout["default"], {
    aside: aside
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, title), date && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], null)
  }, date), price && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_AttachMoney["default"], null)
  }, price), _items.length > 0 && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_History["default"], null),
    valign: "top"
  }, _items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: index,
      className: "pb-2"
    }, /*#__PURE__*/_react["default"].createElement("span", null, item.date), /*#__PURE__*/_react["default"].createElement("span", {
      className: "float-right"
    }, item.price));
  })), !(0, _isNil["default"])(onClick) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-48",
    onClick: onClick
  }, "Pay Bill"));
};
View.displayName = 'Bill';
var _default = exports["default"] = View;
//# sourceMappingURL=Bill.js.map